import { render, staticRenderFns } from "./DevProfile.vue?vue&type=template&id=5f172452&scoped=true&"
import script from "./DevProfile.vue?vue&type=script&lang=js&"
export * from "./DevProfile.vue?vue&type=script&lang=js&"
import style0 from "./DevProfile.vue?vue&type=style&index=0&id=5f172452&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f172452",
  null
  
)

export default component.exports